import { validateForUI } from 'common/helpers/jsonValidator';

const shippingSchema = {
  type: 'object',
  properties: {
    shippingServiceId: { type: 'string', format: 'uuid' },
    requestedDeliveryDate: { type: 'string', format: 'iso-date-time' },
    requestedShipDate: { type: 'string', format: 'iso-date-time' }
  },
  required: ['shippingServiceId'],
  additionalProperties: false
};

export const validateShipping = (shipping) => {
  const errors = validateForUI(shippingSchema, shipping);
  return errors;
};
